import { useQuery } from "react-query";
import { ObjectFeaturesEnum } from "../../common/enums/ObjectFeaturesEnum";
import { DRCXAvailableObjects } from "../../common/models/drcx/DRCXAvailableObjects";
import DRCXConfigurationDataService from "../../services/drcx-configuration-data-service/DRCXConfigurationDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseDRCXAvailableObjectsQueryParameters = {
    customerID: number,
    groupID: number;
    includeDescendentGroups: boolean;
    includeTankBatteries: boolean;
    offline: boolean;
    features?: ObjectFeaturesEnum
} & BaseUseQueryParameters<DRCXAvailableObjects | undefined>;

export function useDRCXAvailableObjects({
    customerID,
    groupID,
    includeDescendentGroups,
    includeTankBatteries,
    offline,
    features,
    enabled,
    onError,
    onSuccess
}: UseDRCXAvailableObjectsQueryParameters) {
    return useQuery<DRCXAvailableObjects | undefined, RestError>(
        keys.availableObjects(
            customerID,
            groupID,
            includeDescendentGroups,
            includeTankBatteries,
            offline
        ),
        ({ signal }) => {
            return DRCXConfigurationDataService.getAvailableObjects(
                customerID,
                groupID,
                includeDescendentGroups,
                includeTankBatteries,
                offline,
                features,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess
        }
    );
}
